import { Component, OnInit } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { Job } from './services/position-services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: []
})
export class AppComponent implements OnInit {
  title = 'app';

  positions: Array<Job> = [];
  rawData: Array<Job> = [];
  totalPosition: number;
  school: string;
  department: string;
  keyword: string;

  constructor(private _httpService: HttpClient) {
  }

  updateSearchHandler(event: CustomEvent) {
    this.school = event.detail.schoolName;
    this.department = event.detail.departmentName;
    this.keyword = event.detail.keyword;
    this.positions = this.rawData;

    if (this.school != null) {
      let str = this.school.toLowerCase();
      if (str !== 'allschools') {
        this.positions = this.positions.filter(item => item.unit_name.toLowerCase().indexOf(str) !== -1);
      }
    }
    if (this.department != null) {
      let str = this.department.toLowerCase();
      if (str !== 'alldepartments') {
        this.positions = this.positions.filter(item => item.unit_name.toLowerCase().indexOf(str) !== -1);
      }
    }
    if (this.keyword != null) {
      let str = this.keyword.trim().toLowerCase();
      if (str !== '') {
        this.positions = this.positions.filter(item => item.unit_name.toLowerCase().indexOf(str) !== -1 || item.name.toLowerCase().indexOf(str) !== -1);
      }
    }
    this.totalPosition = this.positions.length;
  }

  sortData(item) {
    if (item.name === 'dpt') {
      if (item.isAsc) {
        this.positions.sort(function (a, b) { return (a.unit_name < b.unit_name) ? -1 : 1; });
      }
      else {
        this.positions.sort(function (a, b) { return (a.unit_name < b.unit_name) ? 1 : -1; });
      }
    }
    if (item.name === 'title') {
      if (item.isAsc) {
        this.positions.sort(function (a, b) { return (a.name < b.name) ? -1 : 1; });
      }
      else {
        this.positions.sort(function (a, b) { return (a.name < b.name) ? 1 : -1; });
      }
    }
    if (item.name === 'odate') {
      if (item.isAsc) {
        this.positions.sort(function (a, b) { return (a.open_date < b.open_date) ? -1 : 1; });
      }
      else {
        this.positions.sort(function (a, b) { return (a.open_date < b.open_date) ? 1 : -1; });
      }
    }
  }

  ngOnInit() {
    this._httpService.get('api/values').subscribe((values: Array<Job>) => {
      this.rawData = values;
      this.positions = this.rawData;
      this.totalPosition = this.positions.length;
      this.positions.sort(function (a, b) { return (a.open_date < b.open_date) ? 1 : -1; });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts